import * as React from 'react';
import { Button, ExpandableSection, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { SearchEntityType } from 'src/components/search/constants';
import { activeGroupOrWorkspaceId } from 'src/components/dataadvisory/constants';
import { useSearchParams } from 'src/components/search/useSearchParams';

interface QuickFiltersProps {
  activeGroup: string;
  activeWorkspace: any;
}

export const QuickFilters = (props: QuickFiltersProps) => {
  const { setParams } = useSearchParams();

  const handleQuickLink = (entityType: SearchEntityType, ownerFieldName: string) => {
    const ownerId = activeGroupOrWorkspaceId(props);
    setParams({ entityType, filters: { [ownerFieldName]: [ownerId] } });
  };

  return (
    <ExpandableSection headerText='Quick filters' variant='inline' defaultExpanded={true}>
      <SpaceBetween direction='horizontal' size='xs'>
        <Button variant='normal' onClick={() => handleQuickLink(SearchEntityType.Dataset, 'primaryOwner')}>
          My datasets
        </Button>
        <Button variant='normal' onClick={() => handleQuickLink(SearchEntityType.Database, 'owners')}>
          My databases
        </Button>
        <Button variant='normal' onClick={() => handleQuickLink(SearchEntityType.Schema, 'owners')}>
          My schemas
        </Button>
        <Button variant='normal' onClick={() => handleQuickLink(SearchEntityType.Catalog, 'owner')}>
          My catalogs
        </Button>
      </SpaceBetween>
    </ExpandableSection>
  );
};
